import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/bob/left_back.png";

function Applicationbob() {
  return (
    <section
      className="applicationbob"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={6} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              Looking to Ensure The Creation of a Robust Mobile Application?
            </h2>
            <p>
              We ensure quality, reliability, and security when providing
              mobile, web, and enterprise-level solutions. We leverage our years
              of expertise to create ground-breaking and feature-rich
              applications for our customers. Our credible and robust online
              presence, awards, and innovative approach and methodologies
              accelerate business growth, revenue, and more. So, if you’re
              looking to get an ingenious web or app solution for your business,
              just click on the button below.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get in Touch
            </Link>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="my-auto offfset-lg-2 offset-xl-2 offset-md-2"
          >
            <div className="app_img mt-4">
              <StaticImage
                src="../../../images/case-studies/bob/app_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1380}
                height={885}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Applicationbob;
